module.exports = "nb-card nb-card-body,\nnb-card nb-card-footer {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n\n#printf {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  visibility: hidden;\n  z-index: -10; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/qrcode-card/qrcode-card.component.scss
// module id = ./src/app/shared/qrcode-card/qrcode-card.component.scss
// module chunks = main